import i18n from 'i18n'
import * as React from 'react'
import { SelectAjaxSeeker } from 'ui-seeker/core'
import { FORM_URL } from 'app/@common/constants'


export default function SelectPaxStatic({...props}) {
    const myProps = {
        urlAjax: FORM_URL.PAX,
        placeholder: i18n.t('common:filters.allOccupations'),
        formatOptionLabel: opt => {
            const s = String(opt.value || '')
            if (s.length < 2) return opt.label || s
            return `${i18n.t('common:units.adults', { count: parseInt(s[0]) })} ${i18n.t('common:units.kids', { count: parseInt(s[1]) })}`
        },
        isClearable: true,
        icon: { icon: 'user' },
        isMulti: false,
        ...props
    }
    return <SelectAjaxSeeker {...myProps} />
}
